import { Link } from '@bbl-digital/snorre'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import useInitFrequentRecipients from 'Modules/Communication/shared/hooks/useInitFrequentRecipients'
import { MessageTypeEnum } from 'Modules/Communication/shared/models/Recipients'
import { FC, useEffect, useState } from 'react'
import { useAppSelector } from 'shared/store/store'
import { getSendEmailRecipients } from 'shared/store/sendMessage/email/selectors'
import RecipientInput from './RecipientInput'
import { CopyButtons } from './styles'

const SendToRecipients: FC = () => {
  useInitFrequentRecipients(MessageTypeEnum.Email)
  const recipients = useAppSelector(getSendEmailRecipients)

  const hasCCRecipients = !!recipients?.filter(
    (recipient) => recipient.recipientType === RecipientTypeEnum.Cc
  )?.length
  const hasBccRecipients = !!recipients?.filter(
    (recipient) => recipient.recipientType === RecipientTypeEnum.Bcc
  )?.length

  const [ccOpen, setCcOpen] = useState<boolean>(hasCCRecipients)
  const [bccOpen, setBccOpen] = useState<boolean>(hasBccRecipients)

  useEffect(() => {
    if (hasBccRecipients && !bccOpen) setBccOpen(true)
  }, [bccOpen, hasBccRecipients])

  const Actions =
    !ccOpen || !bccOpen ? (
      <CopyButtons>
        {!ccOpen && (
          <Link small onClick={() => setCcOpen(true)} nopadding>
            Kopi:
          </Link>
        )}
        {!bccOpen && (
          <Link small onClick={() => setBccOpen(true)} nopadding>
            Blindkopi:
          </Link>
        )}
      </CopyButtons>
    ) : null

  return (
    <>
      <RecipientInput
        messageType={MessageTypeEnum.Email}
        recipientType={RecipientTypeEnum.To}
        actions={Actions}
        label="Til"
      />

      {ccOpen && (
        <RecipientInput
          messageType={MessageTypeEnum.Email}
          recipientType={RecipientTypeEnum.Cc}
          label="Kopi:"
        />
      )}
      {bccOpen && (
        <RecipientInput
          messageType={MessageTypeEnum.Email}
          recipientType={RecipientTypeEnum.Bcc}
          label="Blindkopi:"
        />
      )}
    </>
  )
}

export default SendToRecipients
